<template lang="pug">
  sui-container
    transition(name="fade")
      sui-dimmer(
        inverted,
        active,
        v-if="loading")
        sui-loader Loading...

    sui-segment(vertical)
      sui-card-group(
        :items-per-row="4",
        stackable)
        team-card(
          v-for="team in teams",
          :key="team.teamId",
          :team="team")
</template>

<script>
import TeamCard from '@/components/team/TeamCard.vue';

export default {
  name: 'Teams',
  components: {
    TeamCard,
  },
  computed: {
    loading() {
      return this.$store.state.loading;
    },
    teams() {
      return this.$store.state.teams.slice(0).sort((a, b) => a.name.localeCompare(b.name));
    },
  },
};
</script>
